import { render } from "./MenuProducts.vue?vue&type=template&id=5fb0bd1d"
import script from "./MenuProducts.vue?vue&type=script&lang=js"
export * from "./MenuProducts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__